export default "__VITE_PUBLIC_ASSET__6f02c62f__"